import { FC } from 'react'

import { useRouter } from '@tanstack/react-router'

import { getLinkByEntityType } from '../../utils/getLinkByEntityType'
import AssignedEntitiesChangedLink from './AssignedEntitiesChangedLink'
import { AssignedEntitiesChangedProps } from './HistoryRecordDetails.types'
import { EntityActionLabels } from './enums'
import getAssignedUnAssignedLists from './getAssignedUnAssignedLists'

const AssignedEntitiesChanged: FC<AssignedEntitiesChangedProps> = (props) => {
  const { entityType, entityTypeLabel, after, before, noLink } = props
  const { assignedList, unAssignedList } = getAssignedUnAssignedLists({ after, before })
  const router = useRouter()

  return (
    <>
      {assignedList.map(({ id, name }) => {
        const to = getLinkByEntityType(entityType, id, router)
        return (
          <AssignedEntitiesChangedLink
            key={`a-${id}`}
            action={EntityActionLabels.ASSIGNED}
            entityTypeLabel={entityTypeLabel}
            elementName={name}
            to={to}
            noLink={noLink}
          />
        )
      })}
      {unAssignedList.map(({ id, name }) => {
        const to = getLinkByEntityType(entityType, id, router)
        return (
          <AssignedEntitiesChangedLink
            key={`u-${id}`}
            action={EntityActionLabels.UNASSIGNED}
            entityTypeLabel={entityTypeLabel}
            elementName={name}
            to={to}
            noLink={noLink}
          />
        )
      })}
    </>
  )
}

export default AssignedEntitiesChanged
